module.exports = __webpack_public_path__ + "static/media/YF16_4.00b74bb2.jpg";